module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5746ae12ca84ea004e747f32438337da.png";